/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import FeelingEvasSectionContent from "parog-web/components/feeling-evas/sliders/component";
import type { EmberChangeset } from "ember-changeset";

interface Signature {
  Args: {
    key: string;
    form: { changeset: EmberChangeset };
  };
}

export default class MiciBaseConsultFormImmediateStoolUrgencyComponent extends FeelingEvasSectionContent<Signature> {
  @action
  onChange(value: number) {
    this.args.form.changeset.set(this.args.key, value.toString());
  }

  get value(): number {
    const existingValue = this.args.form.changeset.get(this.args.key);
    return existingValue ? Number(existingValue) : 0;
  }
}
